import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import React, { useState } from 'react'

const DialogCancel = ({onClickCancel,onClickExit,dialogClose , setDialogClose}) => {
    
  return (
    <Dialog open = {dialogClose}>
    <DialogTitle>Exit Confirmation</DialogTitle>
    <DialogContent>
      <DialogContentText>
        Are you sure you want to exit this page?
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClickCancel} color="primary" variant='outlined'>
        Cancel
      </Button>
      <Button onClick={onClickExit} sx={{color:"red !important",border:"1px solid red !important"}} variant="outlined">
        Exit
      </Button>
    </DialogActions>
  </Dialog>
  )
}

export default DialogCancel